export default __webpack_public_path__ + "static/media/alipayGrey.f16c817b.svg";